export const CAMPAIGN_METRICS = ["Enviado", "Entregado", "Abierto", "Error"];

export const SMS_MAX_LENGTH = 160;

export const CENTRAL_CATALOG_PROVIDERS = [
  { id: "hoya", logo: "/images/support-extra/providers/hoya.svg" },
];

export const CENTRAL_CATALOG_AMBITO_TEXT = {
  L: "Valor independiente para cada lente.",
  E: "Valor aplicable a ambas lentes.",
};

export const CALENDAR_TYPE_OPTIONS = [
  {
    id: "MENSUAL",
    text: "MENSUAL",
  },
  {
    id: "SEMANAL",
    text: "SEMANAL",
  },
  {
    id: "DIARIO",
    text: "DIARIO",
  },
  {
    id: "AGENDA",
    text: "AGENDA",
  },
];

export const CALENDAR_PERMISSIONS = [
  {
    id: "ESCRITURA",
    text: "ESCRITURA",
  },
  {
    id: "LECTURA",
    text: "LECTURA",
  },
];

export const SLOT_HEIGHT = 20;
export const SLOT_TITLE_HEIGHT = 30;

export const CALENDAR_HOURS = [
  {
    id: "00",
    text: "00",
  },
  {
    id: "01",
    text: "01",
  },
  {
    id: "02",
    text: "02",
  },
  {
    id: "03",
    text: "03",
  },
  {
    id: "04",
    text: "04",
  },
  {
    id: "05",
    text: "05",
  },
  {
    id: "06",
    text: "06",
  },
  {
    id: "07",
    text: "07",
  },
  {
    id: "08",
    text: "08",
  },
  {
    id: "09",
    text: "09",
  },
  {
    id: "10",
    text: "10",
  },
  {
    id: "11",
    text: "11",
  },
  {
    id: "12",
    text: "12",
  },
  {
    id: "13",
    text: "13",
  },
  {
    id: "14",
    text: "14",
  },
  {
    id: "15",
    text: "15",
  },
  {
    id: "16",
    text: "16",
  },
  {
    id: "17",
    text: "17",
  },
  {
    id: "18",
    text: "18",
  },
  {
    id: "19",
    text: "19",
  },
  {
    id: "20",
    text: "20",
  },
  {
    id: "21",
    text: "21",
  },
  {
    id: "22",
    text: "22",
  },
  {
    id: "23",
    text: "23",
  },
];

export const CALENDAR_HOURS_COMPLETE = [
  {
    id: "00:00",
    text: "00:00",
  },
  {
    id: "01:00",
    text: "01:00",
  },
  {
    id: "02:00",
    text: "02:00",
  },
  {
    id: "03:00",
    text: "03:00",
  },
  {
    id: "04:00",
    text: "04:00",
  },
  {
    id: "05:00",
    text: "05:00",
  },
  {
    id: "06:00",
    text: "06:00",
  },
  {
    id: "07:00",
    text: "07:00",
  },
  {
    id: "08:00",
    text: "08:00",
  },
  {
    id: "09:00",
    text: "09:00",
  },
  {
    id: "10:00",
    text: "10:00",
  },
  {
    id: "11:00",
    text: "11:00",
  },
  {
    id: "12:00",
    text: "12:00",
  },
  {
    id: "13:00",
    text: "13:00",
  },
  {
    id: "14:00",
    text: "14:00",
  },
  {
    id: "15:00",
    text: "15:00",
  },
  {
    id: "16:00",
    text: "16:00",
  },
  {
    id: "17:00",
    text: "17:00",
  },
  {
    id: "18:00",
    text: "18:00",
  },
  {
    id: "19:00",
    text: "19:00",
  },
  {
    id: "20:00",
    text: "20:00",
  },
  {
    id: "21:00",
    text: "21:00",
  },
  {
    id: "22:00",
    text: "22:00",
  },
  {
    id: "23:00",
    text: "23:00",
  },
];

export const CALENDAR_MINUTES = [
  {
    id: "00",
    text: "00",
  },
  {
    id: "15",
    text: "15",
  },
  {
    id: "30",
    text: "30",
  },
  {
    id: "45",
    text: "45",
  },
];

export const DATE_HOLIDAYS_OPTIONS = [
  {
    id: "Mantener",
    text: "MANTENER",
  },
  {
    id: "Ignorar",
    text: "NO ASIGNAR",
  },
  {
    id: "Lunes",
    text: "PASAR AL LUNES SIGUIENTE",
  },
];

export const PRODUCT_FAMILIES = [
  {
    id: "-1",
    text: "",
  },
  {
    id: "0",
    text: "AUDÍFONOS",
  },
  {
    id: "1",
    text: "LENTES",
  },
  {
    id: "2",
    text: "LENTES CONTACTO",
  },
  {
    id: "3",
    text: "LÍQUIDOS",
  },
  {
    id: "4",
    text: "MONTURAS",
  },
  {
    id: "5",
    text: "VARIOS",
  },
  {
    id: "6",
    text: "SOL",
  },
];

export const LABEL_TYPES = [
  "type1",
  "type2",
  "type3",
  "type4",
  "type5",
  "type6",
];

export const EVENT_STATUS = [
  {
    id: "",
    text: "",
    color: "",
  },
  {
    id: "Asignada",
    text: "ASIGNADA",
    color: "#ffc500",
  },
  {
    id: "Recibida",
    text: "RECIBIDA",
    color: "#229702",
  },
  {
    id: "Perdida",
    text: "PERDIDA",
    color: "#970202",
  },
];

export const MONTHS = [
  {
    id: 1,
    text: "ENERO",
  },
  {
    id: 2,
    text: "FEBRERO",
  },
  {
    id: 3,
    text: "MARZO",
  },
  {
    id: 4,
    text: "ABRIL",
  },
  {
    id: 5,
    text: "MAYO",
  },
  {
    id: 6,
    text: "JUNIO",
  },
  {
    id: 7,
    text: "JULIO",
  },
  {
    id: 8,
    text: "AGOSTO",
  },
  {
    id: 9,
    text: "SEPTIEMBRE",
  },
  {
    id: 10,
    text: "OCTUBRE",
  },
  {
    id: 11,
    text: "NOVIEMBRE",
  },
  {
    id: 12,
    text: "DICIEMBRE",
  },
];

export const LABOR_CONTROL_TYPES = [
  {
    id: "JornadaLaboral",
    text: "JORNADA LABORAL",
  },
  {
    id: "AsuntosPropios",
    text: "ASUNTOS PROPIOS",
  },
  {
    id: "Ausencia",
    text: "AUSENCIA",
  },
  {
    id: "BajaLaboral",
    text: "BAJA LABORAL",
  },
  {
    id: "Festivo",
    text: "FESTIVO",
  },
  {
    id: "Vacaciones",
    text: "VACACIONES",
  },
];

export const LABOR_CONTROL_STATUS = [
  {
    id: "Aviso",
    text: "AVISO",
  },
  {
    id: "Revision",
    text: "REVISIÓN",
  },
  {
    id: "Valido",
    text: "VÁLIDO",
  },
  {
    id: "Anulada",
    text: "ANULADA",
  },
];

export const EMPTY_LOYALTY_CONFIG = {
  id: -1,
  contravalor: 0,
  tipoAsignacion: "Importe",
  porCadaXEurosCompra: 0,
  ptosGeneradosPorXEurosCompra: 0,
  porCadaXEurosAudifonos: 0,
  ptosGeneradosXEurosAudifonos: 0,
  porCadaXEurosCristales: 0,
  ptosGeneradosXEurosCristales: 0,
  porCadaXEurosLentillas: 0,
  ptosGeneradosXEurosLentillas: 0,
  porCadaXEurosLiquidos: 0,
  ptosGeneradosXEurosLiquidos: 0,
  porCadaXEurosMonturas: 0,
  ptosGeneradosXEurosMonturas: 0,
  porCadaXEurosVarios: 0,
  ptosGeneradosXEurosVarios: 0,
  porCadaXEurosSol: 0,
  ptosGeneradosXEurosSol: 0,
};
